'use strict';

(function () {
  'use strict';

  angular.module('msUtility').filter('round', round);

  round.$inject = ['$log'];

  /**
   * Rounds a number to 1 decimal of precision.
   * example: {{ 3.14159265359 | round:1 }} => 3.1
   */
  function round($log) {
    return function (number, precision) {
      if (!_.isNumber(number)) {
        $log.error('round filter: Check your value! ${number} is not a number. Instead, found ', number);
        return 'undefined';
      } else {
        return _.round(number, precision);
      }
    };
  }
})();